module.exports = __webpack_public_path__ + "04_glasses_brown.869f1d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/04_glasses_brown.png
// module id = fB4w
// module chunks = 0